import React, { useEffect, useState } from "react";
// import ConditionReport from "../../model/ConditionReport";
import { ConditionReportOutDTO } from "../../model/ConditionReportBase";
import { UserSummaryOutDTO } from "../../model/User";
import Button from "../common/button/Button";
import ButtonAction from "../common/button/ButtonAction";
import ButtonType from "../common/button/ButtonType";
import DialogWindowType from "../common/dialog_window/DialogWindowType";
import SelectWithSearch from "../common/select_search/SelectSearchSide";
import {User} from "../../model/User";
import SelectSearchOption from "../common/select_search/SelectSearchOption";
import APIEndPoints from "../../utils/APIEndPoints";
import PagedData from "../../model/PagedData";
import { useApiClient } from "../../contexts/ApiClientContext";
import { useAlerts } from "../../contexts/AlertsContext";

interface IConditionReportAddEdit_contributorsProps {
  data: ConditionReportOutDTO;
  alreadySharingUsersIDs: UserSummaryOutDTO[];
  setSharingUsers: any;
  author_id: number;
}

function ConditionReportAddEdit_contributors({
  data,
  alreadySharingUsersIDs,
  setSharingUsers,
  author_id,
}: IConditionReportAddEdit_contributorsProps) {
  // id of the user chosen as candidate
  const [candidateUserID, setCandidateUserID] = useState(-1);
  // display information for the candidate user
  const [candidateUserInfo, setCandidateUserInfo] = useState<User | undefined>(
    undefined
  );
  // list of candidate users
  const [candidateUsersList, setCandidateUsersList] = useState<User[]>([]);
  // keyword to search for users in DB
  const [keywordUsers, setKeywordUsers] = useState("");
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // reference to the alerts system
  const alertsManager = useAlerts();
  // keep the info for the users to be displayed
  const [sharingUsersInfo, setSharingUsersInfo] = useState<User[]>([]);

  useEffect(() => {
    if (data.users) {
      setSharingUsersInfo(JSON.parse(JSON.stringify(data.users)));
    }
  }, [data]);

  const onUserChange = (
    inputId: string,
    value: number | string | undefined
  ) => {
    const valueAsNumber = !value
      ? -1
      : typeof value === "string"
      ? parseInt(value)
      : value;
    setCandidateUserID(valueAsNumber);
    // identify user info from the candidates list
    const auxCandidateUserInfo = candidateUsersList.filter(
      (u) => u.id === valueAsNumber
    );
    if (
      auxCandidateUserInfo &&
      Array.isArray(auxCandidateUserInfo) &&
      auxCandidateUserInfo.length > 0
    ) {
      setCandidateUserInfo(auxCandidateUserInfo[0]);
    }
  };

  const onUserSearch = async (inputID: string, keyword: string) => {
    // we perform the search ONLY when at least three letters have been added
    if (keyword.length < 3) {
      setKeywordUsers(keyword);
      setCandidateUsersList([]);
      return;
    }

    const usersInfo = await apiClient?.get<PagedData<User[]>>({
      url: APIEndPoints.USERS.SEARCH(keyword),
    });
    setKeywordUsers(keyword);
    setCandidateUsersList(usersInfo.items);
  };

  const removeUserFromList = (userId: number) => {
    // create a copy of the users
    let usersCopy: number[] = JSON.parse(
      JSON.stringify(Array.from(alreadySharingUsersIDs))
    );
    // remove the indicated user
    usersCopy = usersCopy.filter((id: number) => id != userId);
    // remove the user from display list
    const usersInfoCopy = JSON.parse(JSON.stringify(sharingUsersInfo));
    for (let i = 0; i < usersInfoCopy.length; i++) {
      if (usersInfoCopy[i].id === userId) {
        usersInfoCopy.splice(i, 1);
        break;
      }
    }
    setSharingUsers(new Set(usersCopy));
    setSharingUsersInfo(usersInfoCopy);
  };

  const addUserToShareList = () => {
    if (candidateUserID != -1) {
      // create a copy of the users
      let usersCopy = JSON.parse(JSON.stringify(alreadySharingUsersIDs));

      // add the new user
      usersCopy.push(candidateUserInfo);
      console.log("%%%%%%%%%%%%%%%%%", usersCopy);
      alreadySharingUsersIDs = usersCopy;
      console.log("%%%%%%%%%%%%%%%%%", alreadySharingUsersIDs);
 
      // // add the display information for the new user
      const usersInfoCopy = JSON.parse(JSON.stringify(sharingUsersInfo));
      usersInfoCopy.push(candidateUserInfo);
      
      // save the updates
      setSharingUsers(usersCopy);
      setSharingUsersInfo(usersInfoCopy);
      // reset all search parameters
      setCandidateUserID(-1);
      setCandidateUserInfo(undefined);
      setKeywordUsers("");
      setCandidateUsersList([]);
    }
  };

  const usersAsOptions = candidateUsersList
    .filter(
      (u) =>
        !alreadySharingUsersIDs?.some((user) => user.id === u.id) &&
        u.id != author_id
    )
    .map((user) => {
      return new SelectSearchOption(user.username, user.id);
    });

  console.log("alreadySharingUsersIDs", alreadySharingUsersIDs);

  return (
    <div className="details-section-content">
      {(!alreadySharingUsersIDs || alreadySharingUsersIDs.length === 0) && (
        <div className="text-left">
          This Condition Report has not been shared yet with any users.
        </div>
      )}
      {sharingUsersInfo &&
        sharingUsersInfo.length > 0 &&
        sharingUsersInfo.map((u) => {
          return (
            <div className="details-grid-element">
              <div className="details-grid-content p-0 flex flex-row">
                <div className="details-grid-description grow">
                  {u.username}
                </div>
                <Button
                  type={ButtonType.ICON}
                  purpose={ButtonAction.DELETE}
                  label=""
                  onClick={() => {
                    alertsManager.showDialogWindow({
                      type: DialogWindowType.CONFIRM,
                      message:
                        "Are you sure you want to remove this user from the list?",
                      cancelLabel: "Cancel",
                      confirmLabel: "Confirm",
                      onConfirm: () => removeUserFromList(u.id),
                    });
                  }}
                />
              </div>
            </div>
          );
        })}
      <div className="details-grid-content p-3 bg-white flex flex-row items-start mb-10 mt-10">
        <div className="grow">
          <SelectWithSearch
            options={usersAsOptions}
            label="Add contributors to this report"
            id="add_to_shared"
            onChange={onUserChange}
            value={candidateUserID}
            noValueMessage={
              "Type at least three letters here to search for users..."
            }
            onSearch={onUserSearch}
            clearFilterLabel="cancel"
          />
        </div>
        {candidateUserID != -1 && (
          <Button
            type={ButtonType.FILL_ICON_TEXT}
            purpose={ButtonAction.CREATE}
            label="Add user"
            onClick={() => addUserToShareList()}
            className="mt-6"
          />
        )}
      </div>
    </div>
  );
}

export default ConditionReportAddEdit_contributors;
